import { render, staticRenderFns } from "./updatastatus.vue?vue&type=template&id=5f62ea4e&scoped=true&"
import script from "./updatastatus.vue?vue&type=script&lang=js&"
export * from "./updatastatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f62ea4e",
  null
  
)

export default component.exports